type CamelCaseKey<S extends string> = S extends `${infer Head}${'_' | '-'}${infer Tail}`
  ? `${Head}${Capitalize<CamelCaseKey<Tail>>}`
  : S;

// Тип-версия recursiveToCamel: превращает snake_case/kebab-case поля DTO (в т.ч. вложенные)
// в camelCase так же, как это делает recursiveToCamel в рантайме. Позволяет выводить модели
// из автоген-типов вместо ручного дублирования полей — см. src/shared/models/journal.ts.
export type CamelCased<T> = T extends readonly (infer U)[]
  ? CamelCased<U>[]
  : T extends Date
    ? T
    : T extends object
      ? { [K in keyof T as K extends string ? CamelCaseKey<K> : K]: CamelCased<T[K]> }
      : T;

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- так и задумано, указываем тип вручную
const nonNullableToCamel = <T = unknown>(item: unknown) =>
  item === null || item === undefined ? item : recursiveToCamel<T>(item);

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- так и задумано, указываем тип вручную
export const recursiveToCamel = <T = unknown>(item: NonNullable<unknown>): T => {
  if (Array.isArray(item)) {
    return item.map((el: unknown) => nonNullableToCamel(el)) as T;
  }

  if (typeof item === 'function' || item !== Object(item)) {
    return item as T;
  }

  return Object.fromEntries(
    Object.entries(item as Record<string, unknown>).map(([key, value]) => [
      key.replace(/([-_][a-z])/gi, (c) => c.toUpperCase().replace(/[-_]/g, '')),
      nonNullableToCamel(value),
    ]),
  ) as T;
};
